import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

import { DialogYesNoComponent } from '@shared/dialogs/dialog-yes-no/dialog-yes-no.component';
import * as fromApp from '@store';
import { logout } from '@store/auth/auth.actions';

@Injectable({
  providedIn: 'root',
})
export class EditMapDeactivateModalService {
  isLoggingOut = false;
  dirty = false;
  navigateAwaySelection$: Subject<boolean> = new Subject<boolean>();

  constructor(public dialog: MatDialog, readonly store: Store<fromApp.AppState>) {
    this.dirty = false;
  }

  open() {
    const dialogRef = this.dialog.open(DialogYesNoComponent, {
      panelClass: 'fc-yes-no-dialog',
      data: {
        title: 'CAUTION - If you navigate away, your map will be lost!',
        line1:
          'Leaving this screen without saving your map will cause all of your unsaved progress on your Carbon Site to be lost.  We suggest saving your site before leaving the map tool, using the "Save & Continue" button.',
        buttonTextYes: "Don't Leave Map",
        buttonTextNo: 'Continue Without Saving',
      },
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== null && result === false) {
        this.navigateAwaySelection$.next(true);
      } else {
        this.navigateAwaySelection$.next(false);
      }
    });
  }

  openForLogout() {
    const dialogRef = this.dialog.open(DialogYesNoComponent, {
      panelClass: 'fc-yes-no-dialog',
      data: {
        title: 'CAUTION - If you navigate away, your map will be lost!',
        line1:
          'Leaving this screen without saving your map will cause all of your unsaved progress on your Carbon Site to be lost.  We suggest saving your site before leaving the map tool, using the "Save & Continue" button.',
        buttonTextYes: "Don't Leave Map",
        buttonTextNo: 'Continue Without Saving',
      },
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== null && result === false) {
        this.isLoggingOut = true;
        this.store.dispatch(logout());
      }
    });
  }
}
